// extracted by mini-css-extract-plugin
export default {"container":"assB4C","titleRow":"CAZVbc","title":"zSAeB6","viewItems":"dYdM2Y","spreadRow":"SbFFvA","total":"AObww4"};